<template>
	<div class="medication_list">
		<van-tabs v-model="tabActiveOld">
			<van-tab title="用药记录">
				<van-list v-model="remindLoading" :finished="remindFinished" finished-text="" @load="onLoad">
					<div class="medication_list_content">
						<div v-for="(item,index ) in remindLogList" :key="index">
							<div class="date">{{ item.date }}</div>
							<medicationItem
								v-for="(son,sIndex) in item.list"
								:status="statusObj[son.reminderStatus]"
								:key="sIndex"
								:title="initTitle(son)"
								:dosage="`${son.medicinalDose||''}${son.doseUnit||''}`"
								:remarks="son.remarks"
								@onClick="goLogDetail(son)"
							/>
						</div>
					</div>
				</van-list>
				<van-empty v-if="remindLogList.length === 0" description="暂无数据"></van-empty>
			</van-tab>
			<van-tab title="服药提醒">
				<div class="medication_list_content">
					<medicationItem
						v-for="(item,index) in medicatinList"
						:key="index"
						:title="initTitle(item)"
						:time="item.scPatientRemindeTimes&&item.scPatientRemindeTimes.map(v=>v.remindTime)"
						:dosage="`${item.medicinalDose||''}${item.doseUnit||''}`"
						:remarks="item.remarks"
						@onClick="goDetail(item)"
					/>
					<van-empty v-if="medicatinList.length === 0" description="暂无数据"></van-empty>
				</div>
			</van-tab>
		</van-tabs>
		<foot-button>
			<van-button
				type="primary"
				block
				@click="$router.push({
					path: `/health/medication`
				})"
			>
				添加用药
			</van-button>
		</foot-button>
		<!-- 底部弹窗 -->
		<van-popup v-model="showDetail" position="bottom" closeable @closed="showDetail= false" round>
			<div class="detail_popup">
				<div class="detail_popup_header" v-if="detail.id" :class="statusObj[detail.reminderStatus]">
					<div class="icon"><van-icon :name="statusPopupObj[detail.reminderStatus].icon" /> </div>
					<div> {{statusPopupObj[detail.reminderStatus].text}}</div>
				</div>
				<div class="detail_popup_content">
					<div class="title">{{ initTitle(detail) }}</div>
					<!-- <div class="label_row">
						<div class="label">每次剂量：</div>
						<div class="text">{{ `${detail.medicinalDose||''}${detail.doseUnit||''}` }}</div>
					</div> -->
					<div class="label_row">
						<div class="label">提醒时间：</div>
						<div
							class="text"
							>{{ `${$moment(detail.gmtCreate).format('YYYY年MM月DD日')} ${detail.remindeTime}` }}</div
						>
					</div>
					<div class="label_row" v-if="detail.remarks">
						<div class="label">备注：</div>
						<div class="text">{{ detail.remarks }}</div>
					</div>
				</div>
				<foot-button v-if="showButton ">
					<van-button color="#F5F6F7" block @click="changeStatus(3)">
						<span style="color: #1F2329;">忘记服药</span>
					</van-button>
					<van-button type="primary" block @click="changeStatus(2)"> 已服药 </van-button>
				</foot-button>
			</div>
		</van-popup>
	</div>
</template>
<script>
import medicationItem from './components/medication-item.vue'
import { mapMutations, mapGetters } from 'vuex'
export default {
    name: 'medicationList',
    components: { medicationItem },
    data () {
        return {
            remindLogList: [],
            remindLoading: false,
            remindFinished: false,
            remind: {
                page: 0,
                limit: 20,
                order: 'desc',
                orderField: 'gmt_create',
            },
            statusObj: {
                1: 'warning',
                2: 'success',
                3: 'error'
            },
            statusPopupObj: {
                3: {
                    text: '漏服药',
                    icon: 'warning',
                    class: 'error'
                },
                1: {
                    text: '未标记用药',
                    icon: 'warning',
                    class: 'warning'
                },
                2: {
                    text: '已服药',
                    icon: 'checked',
                    class: 'success',
                },
                0: {
                    text: '',
                    icon: ''
                }
            },
            showDetail: false,
            detail: {},
            medicatinList: [],
            medication: {
                page: 1,
                limit: 20,
                order: 'desc',
                orderField: 'gmt_create',
            },
            options: {
                medicationType: {
                    0: '降压药',
                    1: '降脂药',
                    2: '降糖药',
                    3: '抗血小板药物',
                    4: '抗凝药',
                    5: '其他药物'
                },
                hypoglycemicType: {
                    1: '-口服降糖药',
                    2: '-胰岛素'
                },
            }
        }
    },
    computed: {
        ...mapGetters('information', ['remindActive']),
        tabActiveOld: {
            get () {
                return this.remindActive
            },
            set (val) {
                this.SET_INFORMATION_REMINDACTIVE(val)
            }
        },
        info () {
            return {
                id: this.$store.getters['account/getPatientId']
            }
        },
        showButton () {
            let ret = false
            if (this.detail.reminderStatus === 1) {
                if (this.detail.finalTime > this.$moment().format('YYYY-MM-DD')) {
                    ret = true
                }
            }
            return ret
        }
    },
    created () {
        this.init()
    },
    methods: {
        ...mapMutations('information', ['SET_INFORMATION_REMINDACTIVE']),
        init () {
            // if (this.tabActiveOld) {

            // } else {

            // }
            this.getMedicationList()

        },
        onLoad () {
            this.remind.page += 1
            this.getRemindLogList()
            console.log('remindFinished')
        },
        initTitle (item) {
            // (${this.options.medicationType[item.medicinalType]}${item.hypoglycemicType ? this.options.hypoglycemicType[item.hypoglycemicType] : ''})
            return `${this.tabActiveOld ? '' : item.remindeTime} ${item.medicinalName} `
        },
        getRemindLogList () {
            this.remindLoading = true
            this.$api.patient.getRemindLogList({
                ...this.remind,
                patientId: this.info.id
            }).then(({ code, data }) => {
                if (!code) {
                    let arr = this.remindLogList
                    data.list.map(v => {
                        let date = this.$moment(v.gmtCreate).format('YYYY-MM-DD')
                        let index = arr.findIndex(r => r.date === date)
                        if (index > -1) {
                            arr[index].list.push(v)
                        } else {
                            arr.push({
                                date,
                                list: [v]
                            })
                        }
                    })
                    this.remindLoading = false
                    if ((this.remind.page * this.remind.limit) >= data.total) {
                        this.remindFinished = true
                    } else {
                        this.remindFinished = false
                    }
                    // this.remindLogList = arr
                }
            }).catch(() => {
                this.remindLoading = false
            })
        },
        getMedicationList () {
            this.$api.patient.getRemindList({
                ...this.medication,
                patientId: this.info.id
            }).then(({ code, data }) => {
                if (!code) {
                    this.medicatinList = data.list
                }
            })
        },
        goDetail (item) {
            this.$router.push({
                path: `/health/medication/${item.id}`
            })
        },
        goLogDetail (item) {
            this.showDetail = true
            this.detail = item
        },
        changeStatus (number) {
            if (number === 3) {
                this.$dialog.confirm({
                    title: '',
                    message: '确定将本次服药标记为漏服药吗？',
                    confirmButtonText: '标记',
                    cancelButtonText: '取消'
                }).then(() => {

                    this.changeStatusFunc(number)

                })
            } else {
                this.changeStatusFunc(number)
            }
        },
        changeStatusFunc (number) {
            this.$api.patient.patientmedicationreminderUpdate({
                id: this.detail.id,
                reminderStatus: number
            }).then(({ code }) => {
                if (!code) {
                    this.detail.reminderStatus = number
                    if (number === 2) {
                        this.$toast('标记为已服药')
                    }
                    this.showDetail = false
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.medication_list {
	&_content {
		padding: 28px 32px;
		.date {
			padding: 40px 0 28px 0;
			color: #000000;
			font-size: 32px;
			font-weight: bold;
		}
	}
}
.detail_popup {
	min-height: 812px;
	&_header {
		font-size: 34px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 120px;
		border-bottom: 1px solid #eeeeee;
		.icon {
			margin-right: 10px;
		}
	}
	.error {
		color: @danger;
	}
	.warning {
		color: @warning;
	}
	.success {
		color: @primary;
	}
	&_content {
		height: 396px;
		padding: 40px;
		.title {
			font-size: 34px;
			color: #1f2329;
			margin-bottom: 16px;
			font-weight: bold;
		}
		.label_row {
			display: flex;
			font-size: 28px;
			margin-bottom: 12px;
			color: #1f2329;
			.label {
				color: #8f959e;
				width: 155px;
				text-align: right;
			}
			.text {
				flex: 1;
			}
		}
	}
}
</style>